import { Getter } from 'vuex'
import { VideoWidgetState } from '../types'
import { RootState } from '@/store/types'

const getProgress: Getter<VideoWidgetState, RootState> = (state) => {
  return state.progress
}

export default getProgress
